/**
 * Created by Kostia Romanov on 25.05.2018.
 */


//models page
function ModelsPage() {}
ModelsPage.reloadTimerId = null;
ModelsPage.reloadTime = 60; //sec, edit here
ModelsPage.lvf = null;

ModelsPage.stopReloadTimer = function() {
  clearInterval(ModelsPage.reloadTimerId);
  ModelsPage.reloadTimerId = null;
};
ModelsPage.startReloadTimer = function() {
  ModelsPage.stopReloadTimer();
  if (ModelsPage.reloadTime > 0) {
    ModelsPage.reloadTimerId = setInterval(ModelsPage.reload, ModelsPage.reloadTime * 1000);
  }
};

ModelsPage.reload = function(fd_search, offset) {
  var modelslist = $(".modelslist"),
      maxpageitems = offset ? offset : Math.max(Config.itemsOnPage, $(".mbox ", modelslist).length);

  if (modelslist.length == 0) return;

  if (fd_search) modelslist.data("fd-search", fd_search);
  var fd = jQuery.merge(
    [
      {"name": "command", "value": "get-models"},
      {"name": "pagenumber", "value": 0},
      {"name": "maxpageitems", "value": maxpageitems}
    ],
    fd_search || modelslist.data("fd-search") || []
  );

  ModelsPage.stopReloadTimer();
  modelslist.removeClass("empty").addClass("loading");

  $.ajax({
    "dataType": "html",
    "type": "POST",
    "url": Config.exec + "/postback/models_page.jsp",
    "data": fd,
    "success": function(res) {
      var html_code = $.trim(res);
      $(".modelslist-dynamic_content", modelslist).html(html_code);
      if (html_code.length > 0) {
        ModelsPage.lvfRun();
        modelslist.removeClass("loading");
      } else {
        modelslist.removeClass("loading").addClass("empty");
      }
      ModelsPage.startReloadTimer();
    }
  });
};

ModelsPage.showMore = function() {
  var offset = $(".modelslist .mbox").length;
  ModelsPage.reload(null, offset + Config.itemsOnPage);
};

ModelsPage.lvfRun = function() {
  if (ModelsPage.lvf != null) {
    ModelsPage.lvf.run({});
  }
};

ModelsPage.init = function(req_params, lvf_servURI, lvfSettings) {
  var fd = [];
  for(var k in req_params) {
    var values = req_params[k];
    for (var i=0; i<values.length; i++) fd.push({"name": k, "value": values[i]});
  }
  $(".modelslist").data("fd-search", fd);
  lvfSettings = $.extend({
    "boxes_sel": ".modelslist .modelslist-dynamic_content .mbox",
    "thumbnail_rsel": ".th a",
    "servURI": lvf_servURI,
    "link_rsel": ".st a"
  }, lvfSettings);



  ModelsPage.lvf = (lvf_servURI != null) ?
    LiveVideoFeed.getInstance(
      lvfSettings
    ) :
    null
  ;
  ModelsPage.lvfRun();
  ModelsPage.startReloadTimer();
};

$(function() {
  if (!$("body").hasClass("page-models")) return;

  //var frm_search = $(document.forms["frm-search_panel"]);
  var frm_search = $("form[name=frm-search_panel]:not(.no-instant-update)");
  frm_search.on("submit", function() {
    // console.dir($(this).serializeArray());
    ModelsPage.reload($(this).serializeArray());
    return false;
  });
  $(frm_search).on("click", ".ios-ui-select", function() {
    frm_search.trigger("submit");
  });
  frm_search.find(".btn_show").on("click", function (e) {
    $(".js-toggle-search_panel").trigger("click");
  });
  $("input,select", frm_search).on("change", function() {
    //frm_search.trigger("submit");
  });
  //
});